/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2013                             *
 *                                                     *
 *******************************************************/

export default class emdbUtils {

  //--------------------------------------------------------------------------------------------------------------------
  //  Publics
  //--------------------------------------------------------------------------------------------------------------------

  getDateFormat (date) {
    const d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
    const m = (date.getMonth() + 1) >= 10 ? (date.getMonth()+1) : '0' + (date.getMonth()+1);
    return d + '/' + m + '/' + date.getFullYear();
  }

}




